module.exports = __webpack_public_path__ + "img/inform-risk.933d7bf4.png";